// src/app/(dashboard)/meter/components/MeterCard.tsx
import Link from "next/link";
import React from "react";
import type { MeterRow } from "../types";
import { Badge } from "./Badge";
import { CopyButton } from "./CopyButton";
import {
  getMeterStatus,
  getRelativeTime,
  formatReadableTime,
} from "../utils/meterStatus";

interface MeterCardProps {
  meter: MeterRow;
  now: number; // required — always pass from MeterListClient's ticker
}

export function MeterCard({ meter, now }: MeterCardProps) {
  const status = getMeterStatus(meter.latest_online_at, now);
  const relativeTime = getRelativeTime(meter.latest_online_at, now);
  const updatedTime = formatReadableTime(meter.updatedAt);

  return (
    <Link
      href={`/meter/${meter.pea_no}`}
      className={[
        "block rounded-2xl border p-4 shadow-sm transition",
        "border-slate-200 bg-white hover:shadow-md hover:ring-1 hover:ring-slate-200",
        "dark:border-slate-800 dark:bg-slate-900 dark:hover:ring-slate-700",
      ].join(" ")}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-1 text-base font-bold leading-tight text-purple-700 dark:text-purple-300">
          {meter.pea_no}
          <CopyButton value={meter.pea_no} label="คัดลอก PEA NO." />
        </div>
        <Badge status={status} />
      </div>

      <div className="mt-2.5 space-y-1 text-[13px] text-slate-700 dark:text-slate-200">
        <div className="flex items-center gap-1">
          <b className="text-slate-900 dark:text-slate-50">MAC Address:</b>{" "}
          {meter.mac_address || "-"}
          {meter.mac_address && (
            <CopyButton value={meter.mac_address} label="คัดลอก MAC" />
          )}
        </div>
        <div>
          <b className="text-slate-900 dark:text-slate-50">ข้อมูลล่าสุด</b>{" "}
          <span
            className={
              status === "online"
                ? "font-medium text-emerald-700 dark:text-emerald-300"
                : status === "offline"
                  ? "text-rose-700 dark:text-rose-300"
                  : ""
            }
          >
            {relativeTime}
          </span>
        </div>
      </div>

      <div className="mt-3 text-xs text-slate-500 dark:text-slate-400">
        Updated: {updatedTime}
      </div>
    </Link>
  );
}
